import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { ClinicStore } from "../../store/clinic/clinic.store";

export const clinicAdminResolver: ResolveFn<any> = async () => {
    const clinicStore = inject(ClinicStore)
    try {
        await clinicStore.getClinicAdmins()
    } catch(err) {
        console.error('Error fetching clinic admins:', err);     
    }
}